module.exports = __webpack_public_path__ + "img/cc-delta.eb97de15.png";